export enum ExtensionType {
	Rails = 'rails',
	Rounding = 'rounding',
	Availability = 'availability'
}

export class Extension<T> {
	readonly type: ExtensionType;
	active: boolean;
	params: T;

	constructor(type: ExtensionType, active: boolean, params: T) {
		this.type = type;
		this.active = active;
		this.params = { ...params };
	}

	copy(): Extension<T> {
		return new Extension(this.type, this.active, this.params);
	}
}

export type RailsParams = {
	railHolesHeight: number;
	railHolesWidth: number;
	distanceBetweenRailHoles: number;
	firstRailHoleDistance: number;
}

export type RoundingParams = {
	leftSideRadius: number;
	rightSideRadius: number;
}